{
  "search": "検索",
  "searchWithin": "検索範囲"
}
